import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-barra-notificacao',
  templateUrl: './barra-notificacao.component.html',
  styleUrls: ['./barra-notificacao.component.css']
})
export class BarraNotificacaoComponent implements OnInit {
  quant_new_not = 1;
  mostra_not = false;
  total_registros;

  constructor( ) {

  }

  ngOnInit() {
  }

  calcula_notificacao() {
    if (this.quant_new_not > 0) {
      this.mostra_not = true;
    }
  }

}
